const helpers = {
  touch_object: (object, property) => {
    // Initializes object properties if they are not initialized.
    object[property] = object[property] || {};
  },

  client: {
    _current_id: null,
    get id() {
      if (!this._current_id) {
        this._current_id = ADV.util.getCurrentClientId();
      }
      return this._current_id;
    },
  },

  get is_adviser_area() {
    return ADV.util.env ? ADV.util.env('isAdviserArea') : undefined;
  },

  get is_consumer_area() {
    return ADV.util.env ? ADV.util.env('isConsumerArea') : undefined;
  },

  find_ancestor: (element, parentSelector) => {
    const matches = element.matches ? 'matches' : 'msMatchesSelector';
    while ((element = element.parentNode) && !element[matches](parentSelector));
    return element;
  },

  scroller(dir) {
    this.setState({
      isScrolling: true,
    });
    const length = 154;
    const duration = 100;
    const dest =
      dir === 'left'
        ? this.scrollContainer.scrollLeft - length
        : this.scrollContainer.scrollLeft + length;
    let diff = -1 * (this.scrollContainer.scrollLeft - dest);
    const per_tick = (diff / duration) * 10;
    const sign = Math.sign(diff);
    const target = this.scrollContainer.scrollLeft + diff;
    const scroller = () => {
      const remainingScroll = sign * Math.min(sign * diff, sign * per_tick);
      diff -= remainingScroll;
      this.scrollContainer.scrollLeft = target - diff;
      if (
        diff === 0.0 ||
        this.scrollContainer.scrollLeft >=
          this.scrollContainer.scrollWidth - this.scrollContainer.offsetWidth ||
        this.scrollContainer.scrollLeft <= 0
      ) {
        this.setState({
          isScrolling: false,
        });
      } else {
        setTimeout(scroller, 10);
      }
    };
    setTimeout(scroller, 10);
  },
};

export var { touch_object } = helpers;
export var { client } = helpers;
export var { is_adviser_area } = helpers;
export var { is_consumer_area } = helpers;
export var { find_ancestor } = helpers;
export var { scroller } = helpers;

export default helpers;
